import axios from '@axios'

const route = 'report/production_by_channel'

export default {
  namespaced: true,
  actions: {
    getAll(context, filter) {
      return axios.post(route, filter)
    },
    exportExcel(context, filter) {
      return axios.post(`${route}/export_excel`, filter, { responseType: 'blob' })
    },
  },
}
